// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import FullScreenErrorModal from '../../../modal/FullScreenErrorModal';
import ModalActionsList from '../../../modal/ModalActionsList';

const BrowserUnsupportedFullScreenWarning = (props) => {
    const actions = [
        { text: 'Install Google Chrome instead...', href: 'https://www.google.com.au/chrome/' },
        { text: 'Continue anyway', func: props.acknowledgeUnsupportedBrowser },
    ];

    return (
        <FullScreenErrorModal>
            <h2>Sorry, your browser isn’t supported yet</h2>
            <p className="explanation">
                We’re working hard to make Milanote work in Microsoft Edge, but we’re not there yet.
            </p>
            <ModalActionsList actions={actions} />
        </FullScreenErrorModal>
    );
};

BrowserUnsupportedFullScreenWarning.propTypes = {
    permissionsError: PropTypes.object,
    currentBoard: PropTypes.object,
    acknowledgeUnsupportedBrowser: PropTypes.func.isRequired,
};

export default BrowserUnsupportedFullScreenWarning;
